import React from "react";
import { BaseTestResultData } from "../../rule-engine-core/Common/Testing/BaseTestResultData";

export const TestContext = React.createContext<BaseTestResultData | undefined>(undefined);
